<template lang="pug">
.no-monster-block.col-12(v-if='!favoriteMonster.name')
  div(v-if='!selectedMonster.name')
    h1 Welcome to
    img.logo(src='../../assets/logo-large@3x.png')
    p
      | Spritely is a world inhabited by elusive, mystical creatures known as Sprites!
      | Sprites start as little fellows that will evolve and grow, developing their unique
      | traits as you complete daily activities in integrated apps.
  .row.selected-monster-row(v-else)
    h2.col-12 To start your journey, select your first Sprite
    .col-12.col-md-6
      .selected-monster
        img.sprite(src='../../assets/sprite-1.svg', v-if='selectedMonster.freeType === 1')
        img.sprite(src='../../assets/sprite-2.svg', v-if='selectedMonster.freeType === 2')
        img.sprite(src='../../assets/sprite-3.svg', v-if='selectedMonster.freeType === 3')
        img.sprite(src='../../assets/sprite-4.svg', v-if='selectedMonster.freeType === 4')
        img.island(src='../../assets/island-1@3x.png')
    .col-12.col-md-6
      .card-wrap
        img.compass(src='../../assets/nav/compass.svg')
        h3 {{ selectedMonster.name }}
        p {{ selectedMonster.description }}
        .btn-green(
          v-if='selectedMonster',
          @click='finalizeMonsterSelection(selectedMonster)') Select {{ selectedMonster.name }}
  .starter-monsters.row
    h2.col-12(v-if='!selectedMonster.name') To start your journey, select your first Sprite
    .col-12.col-md-3(v-for='(monster, index) in monsters', @click='selectMonster(monster)')
      .monster(:class='{selected: isSelected(monster)}')
        img.sprite(src='../../assets/sprite-1.svg', v-if='index === 0')
        img.sprite(src='../../assets/sprite-2.svg', v-if='index === 1')
        img.sprite2(src='../../assets/sprite-3.svg', v-if='index === 2')
        img.sprite2(src='../../assets/sprite-4.svg', v-if='index === 3')
        img.island(src='../../assets/island-1@3x.png', :class='{island2: index === 2 || index === 3}')
</template>

<style lang="scss" scoped>
  @keyframes MoveUpDown {
    0%, 100% {
      top: -60px;
    }
    50% {
      top: -40px;
    }
  }

  .no-monster-block {
    h1 {
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.4;
      letter-spacing: 2px;
      text-align: center;
      color: #6c6d69;
      text-transform: uppercase;
    }

    h2 {
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #363734;
    }

    .logo {
      width: 294.5px;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    .island {
      width: 200px;
    }

    .no-monster, .selected-monster {
      padding: 2em;
      height: 150px;

      .sprite {
        max-height: 100px;
      }
    }

    .selected-monster {
      img {
        display: block;
      }

      .sprite {
        max-height: 200px;
        position: absolute;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        top: -60px;
        animation: MoveUpDown 2s ease infinite;
      }

      .island {
        width: 320px;
        margin: 0 auto;
        margin-top: 2rem;
      }
    }

    .selected-monster-row {
      margin-bottom: 4rem;
    }

    .selected-monster-row h2 {
      margin-bottom: 6rem;
    }

    .starter-monsters {
      margin-top: 2em;

      .sprite {
        max-height: 60px;
      }

      .sprite2 {
        max-height: 100px;
        margin-top: -1em;
      }

      .island2 {
        margin-top: -1em;
      }
    }

    .monster {
      padding: 1em;
      margin-top: 2rem;
      opacity: 0.64;
      transition: opacity ease .4s, margin-top ease .4s;
    }

    .monster:hover {
      cursor: pointer;
      opacity: 1;
      margin-top: 1rem;
    }

    .monster.selected {
      opacity: 1;
    }
  }
</style>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      monsters: [
        {
          name: 'Foliage Walker',
          freeType: 1,
          description: 'Foliage walkers are known for their love of soft surfaces. You’ll find them searching for the plushest flowers to sleep on. They gather leaves and petals to wear for a cozy snooze whenever they like.',
        },
        {
          name: 'Brush Scavenger',
          freeType: 2,
          description: 'The caretakers of the forest. Brush Scavengers plant seeds and tend to baby trees, keeping the forest strong and full of life. They have a habit of picking up anything interesting they find along the way and lugging it around as a trophy.',
        },
        {
          name: 'Blooming Toad',
          freeType: 3,
          description: 'Blooming Toads are silly fellows who spend their days looking for perfect leaves to wear on their heads and backs. When they gather enough, it looks like they have a small plant growing out of them!',
        },
        {
          name: 'Moss Sentry',
          freeType: 4,
          description: 'Hold on to your shiny things! Moss Sentries can’t resist sparkly rocks and gems. They’ll snatch anything that catches their eye and bring it back to their nest to decorate. You’ll often find them sitting in puddles, blending in with the forest floor.',
        },
      ],
      selectedMonster: {
        name: '',
      },
    };
  },
  computed: {
    usersMonsters() {
      return this.$store.state.usersMonsters;
    },
    favoriteMonster() {
      return this.$store.state.favoriteMonster;
    },
  },
  methods: {
    selectMonster(monster) {
      this.selectedMonster = this.selectedMonster === monster ? '' : monster;
    },
    isSelected(monster) {
      return !this.selectedMonster.name || this.selectedMonster.name === monster.name;
    },
    async finalizeMonsterSelection(monster) {
      this.selectedMonster = '';
      this.usersMonsters.push(monster);
      monster.experience = 0;
      monster.level = 0;
      this.$store.commit('favoriteMonster', { monster });

      // this.$store.state.displayAdventureGuide = true;

      // @TODO: Move to action
      const response = await axios.post('/monsters/select-first', {
        monsterName: monster.name,
        freeType: monster.freeType,
      });

      this.$store.commit('favoriteMonster', { monster: response.data.monster });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/SpriteSelect.vue